import { render, staticRenderFns } from "./Amount.vue?vue&type=template&id=3bdaffe1&scoped=true&"
import script from "./Amount.vue?vue&type=script&lang=ts&"
export * from "./Amount.vue?vue&type=script&lang=ts&"
import style0 from "./Amount.vue?vue&type=style&index=0&id=3bdaffe1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdaffe1",
  null
  
)

export default component.exports